export function roundToClosest(num: number, delta: number): number {
  return Math.round(num / delta) * delta;
}
